var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useMediaQuery from "@mui/material/useMediaQuery";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { EditableDataGrid } from "../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { Box, Button, Stack, Typography } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { EyeIcon } from "../../../../fieldFailureReports/assets/svg";
import dayjs from "dayjs";
import { showSurface } from "../../../../../redux/awaitedSurfacesSlice";
import { useAppDispatch } from "../../../../../store/hooks";
import FieldFailureReportDetailsView from "../../../../fieldFailureReports/components/fieldFailureReportDetailsView/FieldFailureReportDetailsDesktopView";
import FieldFailureReportDetailsMobileView from "../../../../fieldFailureReports/components/fieldFailureReportDetailsView/FieldFailureReportDetailsMobileView";
export var ChildFF = function (props) {
    var value = props.value, onChange = props.onChange;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dispatch = useAppDispatch();
    var columns = [{
            type: "string",
            field: "DocumentName",
            headerName: "FFR number",
            minWidth: 150,
            editable: false
        }, {
            type: "string",
            field: "RmName",
            headerName: "RM name",
            editable: false
        }, {
            type: "string",
            field: "AsmName",
            headerName: "ASM name",
            editable: false
        }, {
            type: "string",
            field: "AsmContactNumber",
            headerName: "ASM contact no.",
            editable: false
        }, {
            type: "string",
            field: "BranchState",
            headerName: "State & city",
            editable: false,
            renderCell: function (params) {
                var _params$row$BranchSta, _params$row, _params$row$BranchCit, _params$row2;
                var State = (_params$row$BranchSta = (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.BranchState) !== null && _params$row$BranchSta !== void 0 ? _params$row$BranchSta : ' ';
                var City = (_params$row$BranchCit = (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.BranchCity) !== null && _params$row$BranchCit !== void 0 ? _params$row$BranchCit : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, State), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, City));
            }
        }, {
            type: "string",
            field: "DealerName",
            headerName: "Dealer",
            editable: false,
            renderCell: function (params) {
                var _params$row$DealerNam, _params$row3, _params$row$DealerCod, _params$row4;
                var DealerName = (_params$row$DealerNam = (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.DealerName) !== null && _params$row$DealerNam !== void 0 ? _params$row$DealerNam : ' ';
                var DealerCode = (_params$row$DealerCod = (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.DealerCode) !== null && _params$row$DealerCod !== void 0 ? _params$row$DealerCod : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, DealerName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, DealerCode));
            }
        }, {
            type: "string",
            field: "BranchName",
            headerName: "Branch",
            editable: false
        }, {
            type: "string",
            field: "ModelName",
            headerName: "Model",
            editable: false,
            renderCell: function (params) {
                var _params$row$ModelName, _params$row5, _params$row$ModelCode, _params$row6;
                var ModelName = (_params$row$ModelName = (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.ModelName) !== null && _params$row$ModelName !== void 0 ? _params$row$ModelName : ' ';
                var ModelCode = (_params$row$ModelCode = (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ModelCode) !== null && _params$row$ModelCode !== void 0 ? _params$row$ModelCode : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, ModelName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, ModelCode));
            }
        }, {
            type: "string",
            field: "ChasisNumber",
            headerName: "Chassis number",
            editable: false
        }, {
            type: "string",
            field: "EngineNumber",
            headerName: "Engine number",
            editable: false
        }, {
            type: "string",
            field: "DateOfMfg",
            headerName: "Prod. month",
            editable: false,
            valueFormatter: function (params) { return params ? dayjs(params).format("DD-MM-YYYY") : "-"; }
        }, {
            type: "string",
            field: "PartName",
            headerName: "Part",
            editable: false,
            renderCell: function (params) {
                var _params$row$PartName, _params$row7, _params$row$PartCode, _params$row8;
                var PartName = (_params$row$PartName = (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.PartName) !== null && _params$row$PartName !== void 0 ? _params$row$PartName : ' ';
                var PartCode = (_params$row$PartCode = (_params$row8 = params.row) === null || _params$row8 === void 0 ? void 0 : _params$row8.PartCode) !== null && _params$row$PartCode !== void 0 ? _params$row$PartCode : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, PartName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, PartCode));
            }
        }, {
            type: "string",
            field: "DefectDescription",
            headerName: "Defect",
            editable: false,
            renderCell: function (params) {
                var _params$row$DefectNam, _params$row9, _params$row$DefectCod, _params$row10;
                var DefectDescription = (_params$row$DefectNam = (_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.DefectName) !== null && _params$row$DefectNam !== void 0 ? _params$row$DefectNam : ' ';
                var DefectCode = (_params$row$DefectCod = (_params$row10 = params.row) === null || _params$row10 === void 0 ? void 0 : _params$row10.DefectCode) !== null && _params$row$DefectCod !== void 0 ? _params$row$DefectCod : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, DefectDescription), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, DefectCode));
            }
        }, {
            type: "string",
            field: "KMReading",
            headerName: "KM reading",
            editable: false,
            renderCell: function (params) {
                var _params$row$KMReading, _params$row11;
                return (_params$row$KMReading = (_params$row11 = params.row) === null || _params$row11 === void 0 ? void 0 : _params$row11.KMReading) !== null && _params$row$KMReading !== void 0 ? _params$row$KMReading : '-';
            }
        }, {
            type: "string",
            field: "RepairType",
            headerName: "Repair type",
            editable: false
        }, {
            type: "string",
            field: "DateOfSale",
            headerName: "Sale date",
            editable: false,
            valueFormatter: function (params) { return params ? dayjs(params).format("DD-MM-YYYY") : "-"; }
        }, {
            type: "string",
            field: "RepairDate",
            headerName: "JC open date",
            editable: false,
            valueFormatter: function (params) { return params ? dayjs(params).format("DD-MM-YYYY") : "-"; }
        }, {
            type: "string",
            field: "Plant",
            headerName: "Plant",
            editable: false,
            renderCell: function (params) {
                var _params$row$PlantName, _params$row12, _params$row$PlantCode, _params$row13;
                var PlantName = (_params$row$PlantName = (_params$row12 = params.row) === null || _params$row12 === void 0 ? void 0 : _params$row12.PlantName) !== null && _params$row$PlantName !== void 0 ? _params$row$PlantName : ' ';
                var PlantCode = (_params$row$PlantCode = (_params$row13 = params.row) === null || _params$row13 === void 0 ? void 0 : _params$row13.PlantCode) !== null && _params$row$PlantCode !== void 0 ? _params$row$PlantCode : ' ';
                return PlantName && PlantCode ? /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, PlantName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, PlantCode)) : "-";
            }
        }, {
            field: "View",
            headerName: "View",
            width: 100,
            renderCell: function (prisma) {
                return /*#__PURE__*/ React.createElement(EyeIcon, null);
            }
        }];
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            sx: {
                p: 0,
                pt: 2,
                border: 0,
                borderRadius: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    sx: {
                        border: "none"
                    },
                    spacing: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            justifyContent: "center",
                            display: "flex",
                            mx: 2,
                            spacing: 0,
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'parentFFR',
                                    value: 'Parent FFR',
                                    fontWeight: 'bold',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: "all",
                                    label: '0',
                                    sx: {
                                        ml: 1
                                    },
                                    setFieldProps: function (currentValue) {
                                        var _currentValue$ParamsB, _currentValue$ParamsB2;
                                        return {
                                            type: FormItemTypes.Chip,
                                            label: "".concat((_currentValue$ParamsB = currentValue === null || currentValue === void 0 || (_currentValue$ParamsB2 = currentValue.ParamsBeforeRepairData) === null || _currentValue$ParamsB2 === void 0 ? void 0 : _currentValue$ParamsB2.length) !== null && _currentValue$ParamsB !== void 0 ? _currentValue$ParamsB : 0)
                                        };
                                    },
                                    columnSize: true,
                                    color: "info"
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'expand-button',
                                    columnSize: 0,
                                    color: 'secondary',
                                    size: 'small',
                                    sx: {
                                        p: 0,
                                        fontSize: 'sm'
                                    },
                                    setFormState: function (formValues) {
                                        return {
                                            ParentFFRExpanded: !(formValues !== null && formValues !== void 0 && formValues.ParentFFRExpanded)
                                        };
                                    },
                                    setFieldProps: function (formValues) {
                                        var value = formValues !== null && formValues !== void 0 && formValues.id ? formValues === null || formValues === void 0 ? void 0 : formValues.ParentFFRExpanded : !(formValues !== null && formValues !== void 0 && formValues.ParentFFRExpanded);
                                        return {
                                            type: this.type,
                                            children: value ? [/*#__PURE__*/ React.createElement(ExpandLess, null)] : [/*#__PURE__*/ React.createElement(ExpandMore, null)]
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            orientation: 'horizontal',
                            setFieldProps: function (fromValues) {
                                return {
                                    type: FormItemTypes.Divider,
                                    sx: {
                                        my: 1
                                    },
                                    hidden: fromValues === null || fromValues === void 0 ? void 0 : fromValues.ParentFFRExpanded
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'ParentFFRExpanded',
                    value: false,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: FormItemTypes.Accordian,
                            expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                        };
                    },
                    sx: {
                        border: 'none'
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.List,
                            name: '',
                            value: [value],
                            columnSize: 12,
                            sx: {
                                mb: 2,
                                mx: 2
                            },
                            disableCheckboxSelection: true,
                            variant: 'compact',
                            columns: [{
                                    field: 'DocumentName',
                                    flex: 1,
                                    renderCell: function (_ref) {
                                        var row = _ref.row;
                                        return /*#__PURE__*/ React.createElement(Stack, {
                                            direction: "row",
                                            justifyContent: 'space-between',
                                            alignItems: "center"
                                        }, /*#__PURE__*/ React.createElement(Typography, {
                                            p: 1,
                                            fontSize: 'md'
                                        }, "".concat(row === null || row === void 0 ? void 0 : row.DocumentName)), /*#__PURE__*/ React.createElement(Button, {
                                            variant: "text",
                                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                type: 'Drawer',
                                                                Component: FieldFailureReportDetailsMobileView,
                                                                containerProps: {
                                                                    PaperProps: {
                                                                        sx: {
                                                                            maxWidth: {
                                                                                sm: '90%',
                                                                                md: 750
                                                                            }
                                                                        }
                                                                    },
                                                                    anchor: 'right'
                                                                },
                                                                componentProps: {
                                                                    data: row
                                                                }
                                                            }))];
                                                        case 1: return [2 /*return*/, _a.sent()];
                                                    }
                                                });
                                            }); }
                                        }, "View"));
                                    }
                                }],
                            elements: [{
                                    type: FormItemTypes.CardComponent,
                                    name: "",
                                    label: "",
                                    columnSize: 12,
                                    sx: {
                                        backgroundColor: 'secondary.50',
                                        m: 1,
                                        border: 0
                                    },
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            elements: __spreadArray([], [{
                                                    label: 'RM name',
                                                    filedName: 'RmName'
                                                }, {
                                                    label: 'ASM name',
                                                    filedName: 'AsmName'
                                                }, {
                                                    label: 'ASM contact no.',
                                                    filedName: 'AsmContactNumber'
                                                }, {
                                                    label: 'State & city',
                                                    filedName: 'BranchState',
                                                    secondFieldName: 'BranchCity',
                                                    divider: true
                                                }, {
                                                    label: 'Dealer',
                                                    filedName: 'DealerCode',
                                                    secondFieldName: 'DealerName',
                                                    divider: true
                                                }, {
                                                    label: 'Branch',
                                                    filedName: 'BranchName'
                                                }, {
                                                    label: 'Model',
                                                    filedName: 'ModelCode',
                                                    secondFieldName: 'ModelName',
                                                    divider: true
                                                }, {
                                                    label: 'Chassis number',
                                                    filedName: 'ChasisNumber'
                                                }, {
                                                    label: 'Engine number',
                                                    filedName: 'EngineNumber'
                                                }, {
                                                    label: 'Prod. month',
                                                    filedName: 'DateOfMfg',
                                                    date: true
                                                }, {
                                                    label: 'Part',
                                                    filedName: 'PartCode',
                                                    secondFieldName: 'PartName',
                                                    divider: true
                                                }, {
                                                    label: 'Defect',
                                                    filedName: 'DefectCode',
                                                    secondFieldName: 'DefectName',
                                                    divider: true
                                                }, {
                                                    label: 'KM Reading',
                                                    filedName: 'KMReading'
                                                }, {
                                                    label: 'Repair Type',
                                                    filedName: 'RepairType'
                                                }, {
                                                    label: 'Sale date',
                                                    filedName: 'DateOfSale',
                                                    date: true
                                                }, {
                                                    label: 'JC open date',
                                                    filedName: 'RepairDate',
                                                    date: true
                                                }, {
                                                    label: 'Plant',
                                                    filedName: 'PlantName',
                                                    secondFieldName: 'PlantCode',
                                                    divider: true
                                                }].map(function (item) {
                                                return item.divider ? {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            label: "".concat(item.label, " :"),
                                                            columnSize: 0,
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: "medium",
                                                                fontSize: "sm"
                                                            }
                                                        }, {
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            columnSize: true,
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                            spacing: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: item.filedName,
                                                                    value: '-',
                                                                    fontWeight: "medium",
                                                                    columnSize: 0,
                                                                    fontSize: "sm"
                                                                }, {
                                                                    type: FormItemTypes.Divider,
                                                                    orientation: 'vertical',
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    containerProps: {
                                                                        height: "100%"
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: item.secondFieldName,
                                                                    value: '-',
                                                                    fontWeight: "medium",
                                                                    columnSize: 0,
                                                                    fontSize: "sm"
                                                                }]
                                                        }]
                                                } : {
                                                    type: FormItemTypes.Typography,
                                                    name: item.filedName,
                                                    label: item.label,
                                                    value: '-',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    },
                                                    valueGetter: function (formValues, field) {
                                                        var _field$name, _field$name2;
                                                        return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-';
                                                    }
                                                };
                                            }), true)
                                        }]
                                }],
                            getRowHeight: function () { return 'auto'; }
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            sx: {
                p: 0,
                mt: 2,
                mb: 9,
                pt: 2,
                border: 0,
                borderRadius: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    sx: {
                        border: "none"
                    },
                    spacing: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            justifyContent: "center",
                            display: "flex",
                            mx: 2,
                            spacing: 0,
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ChildFFR',
                                    value: 'Child FFR',
                                    fontWeight: 'bold',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: "all",
                                    label: '0',
                                    sx: {
                                        ml: 1
                                    },
                                    setFieldProps: function (currentValue) {
                                        var _currentValue$ParamsB3, _currentValue$ParamsB4;
                                        return {
                                            type: FormItemTypes.Chip,
                                            label: "".concat((_currentValue$ParamsB3 = currentValue === null || currentValue === void 0 || (_currentValue$ParamsB4 = currentValue.ParamsBeforeRepairData) === null || _currentValue$ParamsB4 === void 0 ? void 0 : _currentValue$ParamsB4.length) !== null && _currentValue$ParamsB3 !== void 0 ? _currentValue$ParamsB3 : 0)
                                        };
                                    },
                                    columnSize: true,
                                    color: "info"
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'expand-button',
                                    columnSize: 0,
                                    color: 'secondary',
                                    size: 'small',
                                    sx: {
                                        p: 0,
                                        fontSize: 'sm'
                                    },
                                    setFormState: function (formValues) {
                                        return {
                                            ChildFFExpanded: !(formValues !== null && formValues !== void 0 && formValues.ChildFFExpanded)
                                        };
                                    },
                                    setFieldProps: function (formValues) {
                                        var value = formValues !== null && formValues !== void 0 && formValues.id ? formValues === null || formValues === void 0 ? void 0 : formValues.ChildFFExpanded : !(formValues !== null && formValues !== void 0 && formValues.ChildFFExpanded);
                                        return {
                                            type: this.type,
                                            children: value ? [/*#__PURE__*/ React.createElement(ExpandLess, null)] : [/*#__PURE__*/ React.createElement(ExpandMore, null)]
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            orientation: 'horizontal',
                            setFieldProps: function (fromValues) {
                                return {
                                    type: FormItemTypes.Divider,
                                    sx: {
                                        my: 1
                                    },
                                    hidden: fromValues === null || fromValues === void 0 ? void 0 : fromValues.ChildFFExpanded
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'ChildFFExpanded',
                    value: false,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: FormItemTypes.Accordian,
                            expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                        };
                    },
                    sx: {
                        border: 'none'
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.List,
                            name: '',
                            value: value === null || value === void 0 ? void 0 : value.childFFR,
                            columnSize: 12,
                            sx: {
                                mb: 2,
                                mx: 2
                            },
                            disableCheckboxSelection: true,
                            variant: 'compact',
                            columns: [{
                                    field: 'DocumentName',
                                    flex: 1,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        return /*#__PURE__*/ React.createElement(Stack, {
                                            direction: "row",
                                            justifyContent: 'space-between',
                                            alignItems: "center"
                                        }, /*#__PURE__*/ React.createElement(Typography, {
                                            p: 1,
                                            fontSize: 'md'
                                        }, "".concat(row === null || row === void 0 ? void 0 : row.DocumentName)), /*#__PURE__*/ React.createElement(Button, {
                                            variant: "text",
                                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                type: 'Drawer',
                                                                Component: FieldFailureReportDetailsMobileView,
                                                                containerProps: {
                                                                    PaperProps: {
                                                                        sx: {
                                                                            maxWidth: {
                                                                                sm: '90%',
                                                                                md: 750
                                                                            }
                                                                        }
                                                                    },
                                                                    anchor: 'right'
                                                                },
                                                                componentProps: {
                                                                    data: row
                                                                }
                                                            }))];
                                                        case 1: return [2 /*return*/, _a.sent()];
                                                    }
                                                });
                                            }); }
                                        }, "View"));
                                    }
                                }],
                            elements: [{
                                    type: FormItemTypes.CardComponent,
                                    name: "",
                                    label: "",
                                    columnSize: 12,
                                    sx: {
                                        backgroundColor: 'secondary.50',
                                        m: 1,
                                        border: 0
                                    },
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            elements: __spreadArray([], [{
                                                    label: 'RM name',
                                                    filedName: 'RmName'
                                                }, {
                                                    label: 'ASM name',
                                                    filedName: 'AsmName'
                                                }, {
                                                    label: 'ASM contact no.',
                                                    filedName: 'AsmContactNumber'
                                                }, {
                                                    label: 'State & city',
                                                    filedName: 'BranchState',
                                                    secondFieldName: 'BranchCity',
                                                    divider: true
                                                }, {
                                                    label: 'Dealer',
                                                    filedName: 'DealerCode',
                                                    secondFieldName: 'DealerName',
                                                    divider: true
                                                }, {
                                                    label: 'Branch',
                                                    filedName: 'BranchName'
                                                }, {
                                                    label: 'Model',
                                                    filedName: 'ModelCode',
                                                    secondFieldName: 'ModelName',
                                                    divider: true
                                                }, {
                                                    label: 'Chassis number',
                                                    filedName: 'ChasisNumber'
                                                }, {
                                                    label: 'Engine number',
                                                    filedName: 'EngineNumber'
                                                }, {
                                                    label: 'Prod. month',
                                                    filedName: 'DateOfMfg',
                                                    date: true
                                                }, {
                                                    label: 'Part',
                                                    filedName: 'PartCode',
                                                    secondFieldName: 'PartName',
                                                    divider: true
                                                }, {
                                                    label: 'Defect',
                                                    filedName: 'DefectCode',
                                                    secondFieldName: 'DefectName',
                                                    divider: true
                                                }, {
                                                    label: 'KM Reading',
                                                    filedName: 'KMReading'
                                                }, {
                                                    label: 'Repair Type',
                                                    filedName: 'RepairType'
                                                }, {
                                                    label: 'Sale date',
                                                    filedName: 'DateOfSale',
                                                    date: true
                                                }, {
                                                    label: 'JC open date',
                                                    filedName: 'RepairDate',
                                                    date: true
                                                }, {
                                                    label: 'Plant',
                                                    filedName: 'PlantName',
                                                    secondFieldName: 'PlantCode',
                                                    divider: true
                                                }].map(function (item) {
                                                return item.divider ? {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            label: "".concat(item.label, " :"),
                                                            columnSize: 0,
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: "medium",
                                                                fontSize: "sm"
                                                            }
                                                        }, {
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            columnSize: true,
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                            spacing: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: item.filedName,
                                                                    value: '-',
                                                                    fontWeight: "medium",
                                                                    columnSize: 0,
                                                                    fontSize: "sm"
                                                                }, {
                                                                    type: FormItemTypes.Divider,
                                                                    orientation: 'vertical',
                                                                    name: '',
                                                                    columnSize: 0,
                                                                    containerProps: {
                                                                        height: "100%"
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: item.secondFieldName,
                                                                    value: '-',
                                                                    fontWeight: "medium",
                                                                    columnSize: 0,
                                                                    fontSize: "sm"
                                                                }]
                                                        }]
                                                } : {
                                                    type: FormItemTypes.Typography,
                                                    name: item.filedName,
                                                    label: item.label,
                                                    value: '-',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    },
                                                    valueGetter: function (formValues, field) {
                                                        var _field$name3, _field$name4;
                                                        return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-';
                                                    }
                                                };
                                            }), true)
                                        }]
                                }],
                            getRowHeight: function () { return 'auto'; }
                        }]
                }]
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: [value],
        onChange: onChange,
        disableAddRow: true,
        dataGridHeader: "Parent FFR",
        disableDeleteRow: true,
        disableToolbarActions: true,
        isCollapsible: true,
        dataGridProps: {
            sx: {
                marginBottom: 2
            },
            initialState: {
                pinnedColumns: {
                    left: ['ffrNumber'],
                    right: ["View"]
                },
                density: "standard"
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            onCellClick: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(params.field === "DocumentName" || params.field === "View")) return [3 /*break*/, 5];
                            if (!lgMode) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch(showSurface({
                                    type: 'Drawer',
                                    Component: FieldFailureReportDetailsView,
                                    containerProps: {
                                        PaperProps: {
                                            sx: {
                                                maxWidth: {
                                                    sm: '90%',
                                                    md: 750
                                                }
                                            }
                                        },
                                        anchor: 'right'
                                    },
                                    componentProps: {
                                        data: params.row
                                    }
                                }))];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, dispatch(showSurface({
                                type: 'Drawer',
                                Component: FieldFailureReportDetailsMobileView,
                                containerProps: {
                                    PaperProps: {
                                        sx: {
                                            maxHeight: {
                                                sm: 400,
                                                md: 400
                                            },
                                            height: {
                                                sm: 400,
                                                md: 400
                                            }
                                        }
                                    },
                                    anchor: 'bottom'
                                },
                                componentProps: {
                                    data: params.row
                                }
                            }))];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            _a;
                            _b.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); }
        }
    }), /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: value === null || value === void 0 ? void 0 : value.childFFR,
        onChange: onChange,
        disableAddRow: true,
        dataGridHeader: "Child FFR",
        disableDeleteRow: true,
        disableToolbarActions: true,
        isCollapsible: true,
        dataGridProps: {
            initialState: {
                pinnedColumns: {
                    left: ['ffrNumber'],
                    right: ["View"]
                },
                density: "standard"
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            onCellClick: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(params.field === "DocumentName" || params.field === "View")) return [3 /*break*/, 5];
                            if (!lgMode) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch(showSurface({
                                    type: 'Drawer',
                                    Component: FieldFailureReportDetailsView,
                                    containerProps: {
                                        PaperProps: {
                                            sx: {
                                                maxWidth: {
                                                    sm: '90%',
                                                    md: 750
                                                }
                                            }
                                        },
                                        anchor: 'right'
                                    },
                                    componentProps: {
                                        data: params.row
                                    }
                                }))];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, dispatch(showSurface({
                                type: 'Drawer',
                                Component: FieldFailureReportDetailsMobileView,
                                containerProps: {
                                    PaperProps: {
                                        sx: {
                                            maxHeight: {
                                                sm: 400,
                                                md: 400
                                            },
                                            height: {
                                                sm: 400,
                                                md: 400
                                            }
                                        }
                                    },
                                    anchor: 'bottom'
                                },
                                componentProps: {
                                    data: params.row
                                }
                            }))];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            _a;
                            _b.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); }
        }
    })) : /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            spacing: 0,
            p: 0
        }
    });
};
